import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom/client";
import Pickfox from "../../pickfox-prototype-v6.jsx";
import { Login } from "./Login.jsx";
import { Operator } from "./Operator.jsx";
import { supabase } from "./lib/supabase.js";

const globalStyle = document.createElement("style");
globalStyle.textContent = `
  html, body { margin: 0; padding: 0; background: #f5f1e8; }
  #root { display: flex; justify-content: center; min-height: 100vh; }
  #root > * { width: 100%; max-width: 480px; }
`;
document.head.appendChild(globalStyle);

function App() {
  const [session, setSession] = useState(null);
  const [checking, setChecking] = useState(true);
  const [profileRow, setProfileRow] = useState(null);
  const [mode, setMode] = useState("app");

  useEffect(() => {
    supabase.auth.getSession().then(({ data }) => {
      setSession(data.session);
      setChecking(false);
    });
    const { data: { subscription } } = supabase.auth.onAuthStateChange(
      (_event, newSession) => setSession(newSession)
    );
    return () => subscription.unsubscribe();
  }, []);

  useEffect(() => {
    if (!session) { setProfileRow(null); return; }
    supabase.from("profiles").select("*").eq("id", session.user.id).single()
      .then(({ data, error }) => { if (!error) setProfileRow(data); });
  }, [session]);

  if (checking) {
    return <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", color: "#a8a29e", fontFamily: "system-ui, sans-serif" }}>Loading…</div>;
  }
  if (!session) return <Login />;
  if (mode === "operator" && profileRow?.is_operator) {
    return <Operator onBack={() => setMode("app")} />;
  }
  return <Pickfox onOpenOperator={profileRow?.is_operator ? () => setMode("operator") : undefined} />;
}

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
